<div class="card bg-white">
  <div class="card-body ">
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label for="data_pagamento_p" class="control-label col-form-label">Data Inizio: </label>
          <input type="date" [(ngModel)]="inizio" class="form-control" (ngModelChange)="refresh()"
                 id="data_pagamento_p">
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="data_pagamento_e" class="control-label col-form-label">Data Fine: </label>
          <input type="date" [(ngModel)]="fine" class="form-control" (ngModelChange)="refresh()"
                 id="data_pagamento_e">
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="form-group">
          <label for="fornitore" class="control-label col-form-label">{{'Agenzia' | translate}}</label>
          <ng-multiselect-dropdown [settings]="personedropdownSettings" [placeholder]="'Agenzia' | translate" id="fornitore"
                                   [data]="Agenzie" [(ngModel)]="AgenzieSelezionate" >
          </ng-multiselect-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="row">
    <div class="col-md-4">
      <div class="card bg-success align-items-center">
        <div class="card-body text-white align-items-center">
          <div class="d-flex no-block">
            <div class="m-r-20 align-self-center"><img src="assets/images/icon/expense-w.png" alt="Income" /></div>
            <div class="align-self-center">
              <h2 class="text-white m-t-10 m-b-0">Fatturato</h2>
              <h1 class="m-t-0 text-white">{{data?.totale?.replace('.',',')}} €</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div class=" col-md-4">
    <div class="card bg-orange align-items-center">
      <div class="card-body text-white align-items-center">
        <div class="d-flex no-block">
          <div class="m-r-20 align-self-center"><img src="assets/images/icon/expense-w.png" alt="Income" /></div>
          <div class="align-self-center">
            <h2 class="text-white m-t-10 m-b-0">Costi(Spese)</h2>
            <h1 class="m-t-0 text-white">{{data?.spese?.replace('.',',')}} €</h1></div>
        </div>
      </div>
    </div>
  </div>

  <div class=" col-md-4">
    <div class="card bg-cyan align-items-center">
      <div class="card-body text-white align-items-center">
        <div class="d-flex no-block">
          <div class="m-r-20 align-self-center"><img src="assets/images/icon/expense-w.png" alt="Income" /></div>
          <div class="align-self-center">
            <h2 class="text-white m-t-10 m-b-0">Margine</h2>
            <h1 class="m-t-0 text-white">{{data?.margine?.replace('.',',')}} €</h1></div>
        </div>
      </div>
    </div>
  </div>

  <div class=" col-md-4">
    <div class="card bg-purple align-items-center">
      <div class="card-body text-white align-items-center">
        <div class="d-flex no-block">
          <div class="m-r-20 align-self-center"><img src="assets/images/icon/expense-w.png" alt="Income" /></div>
          <div class="align-self-center">
            <h2 class="text-white m-t-10 m-b-0">Insoluto Cliente</h2>
            <h1 class="m-t-0 text-white">{{data?.ins_cliente?.replace('.',',')}} €</h1></div>
        </div>
      </div>
    </div>
  </div>

  <div class=" col-md-4">
    <div class="card bg-dark align-items-center">
      <div class="card-body text-white align-items-center">
        <div class="d-flex no-block">
          <div class="m-r-20 align-self-center"><img src="assets/images/icon/expense-w.png" alt="Income" /></div>
          <div class="align-self-center">
            <h2 class="text-white m-t-10 m-b-0">Insoluto Corriere</h2>
            <h1 class="m-t-0 text-white">{{data?.ins_corriere?.replace('.',',')}} €</h1></div>
        </div>
      </div>
    </div>
  </div>

  <div class=" col-md-4">
    <div class="card bg-white align-items-center">
        <div class="card-body text-dark align-items-center">
          <div class="d-flex no-block ">
            <div class="m-r-20 align-self-center"><img src="assets/images/icon/expense-w.png" alt="Income" /></div>
            <div class="align-self-center">
              <h2 class="text-dark m-t-10 m-b-0">Numero Spedizioni</h2>
              <h1 class="m-t-0 text-dark">{{data?.num_sped}}</h1>
            </div>
          </div>
        </div>
    </div>
  </div>

  <!--  <div class="col-lg-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Fatturato (€)</h4>
          <apx-chart [series]="costi_Graphic_Data.series" [chart]="costi_Graphic_Data.chart" [colors]="costi_Graphic_Data.colors" [labels]="costi_Graphic_Data.labels"
                     [fill]="costi_Graphic_Data.fill" [stroke]="costi_Graphic_Data.stroke" [responsive]="costi_Graphic_Data.responsive">
          </apx-chart>
        </div>
      </div>
    </div>-->
    <div class="col-lg-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Pagam Corriere (€)</h4>
          <apx-chart [series]="imp_corrieri_Graphic_Data.series" [chart]="imp_corrieri_Graphic_Data.chart" [colors]="imp_corrieri_Graphic_Data.colors"  [labels]="imp_corrieri_Graphic_Data.labels"
                     [fill]="imp_corrieri_Graphic_Data.fill" [stroke]="imp_corrieri_Graphic_Data.stroke" [responsive]="imp_corrieri_Graphic_Data.responsive">
          </apx-chart>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">N.Spedizioni Corriere</h4>
          <apx-chart [series]="sped_corrieri_Graphic_Data.series" [chart]="sped_corrieri_Graphic_Data.chart" [colors]="sped_corrieri_Graphic_Data.colors" [labels]="sped_corrieri_Graphic_Data.labels"
                     [fill]="sped_corrieri_Graphic_Data.fill" [stroke]="sped_corrieri_Graphic_Data.stroke" [responsive]="sped_corrieri_Graphic_Data.responsive">
          </apx-chart>
        </div>
      </div>
    </div>
  <div class="col-md-6">
    <app-group-vertical-bar-chart [xAxisLabel]="''" [hasSearch]="false" [yAxisLabel]="''" [data]="resoconto_Graphic_Data" [titolo]="'Resoconto (€)'" ></app-group-vertical-bar-chart>
<!--    <app-pie [single]="costi_Graphic_Data" [titolo]="'Fatturato (€)'"></app-pie>-->
  </div>

<!--  <div class="col-md-6">-->
<!--        <app-pie [single]="imp_corrieri_Graphic_Data" [titolo]="'Pagam Corriere (€)'"></app-pie>-->
<!--  </div>-->
<!--  <div class="col-md-6">-->
<!--    <app-pie [single]="sped_corrieri_Graphic_Data" [titolo]="'N.Spedizioni Corriere'"></app-pie>-->
<!--  </div>-->

</div>
